import { styled } from 'goober';
import { COLORS } from '../../../shared/config/colors/colors';
import { baseShadowStyle } from '../../../shared/style/base-shadow';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100dvh;
    justify-content: center;
    background-color: ${COLORS.newBg};
`;

export const Content = styled('div')`
    display: flex;
    flex-grow: 1;
    ${baseShadowStyle}
`;

export const LeftSide = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 36px;
    flex-basis: 50%;
    padding: 40px;
    background-color: ${COLORS.neutral_00};
    ${baseShadowStyle}
`;

export const Banner = styled('img')`
    width: 100%;
    border-radius: 20px;
`;

export const WelcomInfo = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ListWrapper = styled('div')`
    display: flex;
    gap: 70px;
`;

export const List = styled('ul')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-left: 24px;
`;

export const RightSide = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: 50%;
    padding: 0 40px;
`;

export const ScrollOffset = styled('div')`
    display: flex;
    width: 500px;
    padding: 40px;
    background-color: ${COLORS.neutral_00};
    border-radius: 12px;
    ${baseShadowStyle}
`;
